import React from 'react';

const CollapseIcon:React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="13.249" viewBox="0 0 15 13.249">
        <path id="chevron" d="M1153.329,9276.95a1.07,1.07,0,0,1-.328-.78,1.117,1.117,0,0,1,.3-.78l4.1-4.266-4.1-4.265a1.114,1.114,0,0,1-.3-.78,1.017,1.017,0,0,1,.328-.764,1.107,1.107,0,0,1,1.558.012l4.813,5.031a1.127,1.127,0,0,1,0,1.532l-4.812,5.031a1.08,1.08,0,0,1-.794.328A1.1,1.1,0,0,1,1153.329,9276.95Zm-7,0a1.07,1.07,0,0,1-.328-.78,1.118,1.118,0,0,1,.3-.78l4.1-4.266-4.1-4.265a1.114,1.114,0,0,1-.3-.78,1.016,1.016,0,0,1,.328-.764,1.081,1.081,0,0,1,.78-.314,1.064,1.064,0,0,1,.778.326l4.813,5.031a1.121,1.121,0,0,1,0,1.532l-4.813,5.031a1.074,1.074,0,0,1-.792.328A1.1,1.1,0,0,1,1146.328,9276.95Z" transform="translate(-1145.5 -9264.501)" fill="#ebecf0" stroke="rgba(0,0,0,0)" stroke-width="1"/>
    </svg>
  )
}

export default CollapseIcon;